import type { FC } from "react";
import { View } from "react-native";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { Icon, Text } from "@visioni/a3s-ui/components";
import "@visioni/a3s-ui/theme";
import { ScheduleRow } from "../ScheduleRow";

export interface SentToFieldProps {
  /** The signed-in user's email; empty when the app doesn't know it. */
  readonly email: string;
}

/** Shown when the email isn't known, rather than leaving the row blank. */
const UNKNOWN_EMAIL = "The email address on your account";

/** Where the report email goes: always the signed-in user, so it's read-only. */
export const SentToField: FC<SentToFieldProps> = ({ email }) => {
  const { theme } = useUnistyles();
  return (
    <ScheduleRow label="Sent to" helperText="The email you sign in with. Each person sets up their own.">
      <View style={styles.value}>
        <Icon name="lockClosed" size={14} color={theme.colors.textMuted} />
        {email !== "" ?
          <Text textStyle="sm/regular" color="text" numberOfLines={1}>
            {email}
          </Text>
        : <Text textStyle="sm/regular" color="textMuted" numberOfLines={1}>
            {UNKNOWN_EMAIL}
          </Text>
        }
      </View>
    </ScheduleRow>
  );
};

const styles = StyleSheet.create((theme) => ({
  value: {
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing.md,
    minWidth: 0,
  },
}));
